import { render, staticRenderFns } from "./PsiDiagnostic.vue?vue&type=template&id=41c5f9a1&scoped=true"
import script from "./PsiDiagnostic.vue?vue&type=script&lang=js"
export * from "./PsiDiagnostic.vue?vue&type=script&lang=js"
import style0 from "./PsiDiagnostic.vue?vue&type=style&index=0&id=41c5f9a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c5f9a1",
  null
  
)

export default component.exports